import { IFiltersList } from "@/src/types/applicationOnline";
import { ITasksTableRow } from "@/src/types/tasksTable";

const uniqueStrings = (values: string[]): string[] =>
  Array.from(new Set(values.map((value) => value.trim()).filter((value) => value !== "")));

export const buildTasksFiltersList = (rows: ITasksTableRow[]): IFiltersList => ({
  type: uniqueStrings(rows.map((row) => row.type)) as [],
  status: uniqueStrings(rows.map((row) => row.status)) as [],
  course: uniqueStrings(rows.map((row) => row.course)) as [],
  assignee: uniqueStrings(rows.map((row) => String(row.assignee_id || row.assignee_email || ""))) as [],
  is_read: uniqueStrings(rows.map((row) => (row.is_read ? "true" : "false"))) as [],
  color_star: uniqueStrings(rows.map((row) => row.color_star)) as [],
  country: uniqueStrings(rows.map((row) => row.category)) as [],
});

export const mergeTasksFiltersList = (apiList?: IFiltersList | null, dataList?: IFiltersList): IFiltersList | undefined => {
  if (!apiList && !dataList) return undefined;

  const mergeValues = (key: keyof IFiltersList) => {
    const fromApi = Array.isArray(apiList?.[key]) ? apiList![key].map(String) : [];
    const fromData = Array.isArray(dataList?.[key]) ? dataList![key].map(String) : [];
    return Array.from(new Set([...fromApi, ...fromData])) as IFiltersList[typeof key];
  };

  return {
    type: mergeValues("type"),
    status: mergeValues("status"),
    course: mergeValues("course"),
    assignee: mergeValues("assignee"),
    is_read: mergeValues("is_read"),
    color_star: mergeValues("color_star"),
    country: mergeValues("country"),
  };
};
